var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage face-flip"
  }, [_c('div', {
    staticClass: "cards-container"
  }, _vm._l(_vm.currentRound.steps, function (card, index) {
    return _c('figure', {
      key: ("card-" + index),
      class: ("figure-type-" + (_vm.currentRound.steps.length)),
      attrs: {
        "id": ("drop-" + index)
      }
    }, [_c('svg', {
      attrs: {
        "width": "100%",
        "height": "100%"
      }
    }, [_c('image', {
      attrs: {
        "xlink:href": card.images.letter,
        "width": "100%",
        "height": "100%"
      }
    }), _c('image', {
      staticClass: "mainImg",
      attrs: {
        "xlink:href": card.images.main,
        "width": "100%",
        "height": "100%",
        "y": "28%"
      }
    }), !_vm.isMatched[("m" + index)] ? _c('image', {
      attrs: {
        "xlink:href": card.images.puzzlePiece.missing,
        "width": ((card.images.puzzlePiece.width) + "%"),
        "height": "100%",
        "x": ((card.images.puzzlePiece.x) + "%"),
        "y": ((card.images.puzzlePiece.y) + "%")
      }
    }) : _vm._e()]), _vm.caption[("c" + index)] ? _c('figcaption', [_c('b', {
      domProps: {
        "textContent": _vm._s(card.name)
      }
    })]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "puzzles-container"
  }, _vm._l(_vm.currentRound.steps, function (card, index) {
    return _c('figure', {
      key: ("puzzle-" + index),
      class: ("figure-card figure-type-" + (_vm.currentRound.steps.length)),
      style: ("order: " + (card.order) + ";"),
      attrs: {
        "id": ("drag-" + index)
      }
    }, [_c('svg', {
      attrs: {
        "width": "100%",
        "height": "100%"
      }
    }, [_c('mask', {
      style: _vm.maskStyle[index],
      attrs: {
        "id": ("mask-" + index)
      }
    }, [_c('image', {
      attrs: {
        "xlink:href": card.images.puzzlePiece.full,
        "width": ((card.images.puzzlePiece.width + 11) + "%"),
        "height": "100%",
        "x": ((card.images.puzzlePiece.x - 6.5) + "%"),
        "y": ((card.images.puzzlePiece.y) + "%")
      }
    })]), _c('image', {
      attrs: {
        "xlink:href": card.images.puzzlePiece.full,
        "width": ((card.images.puzzlePiece.width + 11) + "%"),
        "height": "100%",
        "x": ((card.images.puzzlePiece.x - 6.5) + "%"),
        "y": ((card.images.puzzlePiece.y) + "%")
      }
    }), _c('svg', {
      style: _vm.svgStyle[index],
      attrs: {
        "width": "100%",
        "mask": ("url(#mask-" + index + ")")
      }
    }, [_c('image', {
      attrs: {
        "xlink:href": card.images.letter,
        "width": "100%",
        "height": "100%"
      }
    }), _c('image', {
      attrs: {
        "xlink:href": card.images.main,
        "width": "100%",
        "height": "100%",
        "y": "28%"
      }
    })])])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }